<ng-container *transloco="let translate">
  <button class="learn-more">
    <span class="circle" aria-hidden="true">
      <span class="icon arrow"></span>
    </span>
    <span class="button-text">{{ translate('cv.shared.slideButton') }}</span>
  </button>
</ng-container>
